'use client';

import React from 'react';
import { TasticProps } from '../types';

type MaintenanceTasticData = {
  title?: string;
  summary?: string;
};

const MaintenanceTastic = ({ data }: TasticProps<MaintenanceTasticData>) => {
  console.log('MaintenanceTastic data', data);

  if (!data?.title || !data?.summary) {
    return <></>;
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-neutral-50 px-4 text-center">
      <div className="max-w-xl">
        <h1 className="mb-4 text-3xl font-semibold text-neutral-900">{data.title}</h1>
        <p className="text-base text-neutral-600">{data.summary}</p>
      </div>
    </div>
  );
};

export default MaintenanceTastic;
